export default {
  modalTitle: {
    id: 'address_book_rules_modal_title',
    defaultMessage: 'New rule',
  },
  addressStep: {
    id: 'address_book_rules_address_step',
    defaultMessage: 'Addresses',
  },
  servicesStep: {
    id: 'address_book_rules_activities_step',
    defaultMessage: 'Activities',
  },
  marketsStep: {
    id: 'address_book_rules_markets_step',
    defaultMessage: 'Markets',
  },
  categoriesStep: {
    id: 'address_book_rules_categories_step',
    defaultMessage: 'Categories',
  },
  confirmationStep: {
    id: 'address_book_rules_confirmation_step',
    defaultMessage: 'Confirmation',
  },
  fetching: {
    id: 'address_book_rules_form_fetching',
    defaultMessage: 'Fetching info...',
  },
}
